export default {"src":"/_next/static/image/public/images/rxHome.e9c51fabbc3f0d8ade10730541b4defb.svg","height":88,"width":101};